import { css } from '@emotion/core';

import { fontStack } from '@/styles';

import { SEARCH_MIN_HEIGHT } from '../styles';

export const root = css`
  display: flex;
  flex-flow: row;
  align-items: center;
  min-height: ${SEARCH_MIN_HEIGHT};
  width: auto;
  padding: 4px;

  input#searchInput {
    width: auto;
    height: 100%;
    padding: 2px 8px;
    border: 0;
    overflow: visible;
    background-color: transparent;
    ${fontStack};

    /* NOTE: Reset the focus */
    &:focus {
      outline: none;
    }

    /**
   * NOTE:
   * Hides seach-cancel-button so we show the AK CrossIcon
  */
    &::-webkit-search-cancel-button {
      display: none;
    }
  }
`;
